// src/components/FAQSection.tsx
import { useState } from "react";
import SectionHeading from "./SectionHeading";
import { FAQ } from "../data/content.js";

export default function FAQSection() {
  const [open, setOpen] = useState<number | null>(0);
  return (
    <section style={{ padding: "64px 48px", position: "relative", zIndex: 1 }}>
      <SectionHeading eyebrow="FAQ" title="Frequently Asked" accent="Questions" center />
      <div style={{ maxWidth: 720, margin: "0 auto", display: "flex", flexDirection: "column", gap: 8 }}>
        {FAQ.map((item, i) => (
          <div key={i} style={{
            background: "var(--bg2)", border: "1px solid rgba(124,58,237,.2)",
            borderRadius: 10, overflow: "hidden",
            borderColor: open === i ? "rgba(124,58,237,.4)" : "rgba(124,58,237,.2)",
          }}>
            <button onClick={() => setOpen(open === i ? null : i)} style={{
              width: "100%", padding: "16px 20px", display: "flex", alignItems: "center", justifyContent: "space-between",
              background: "transparent", border: "none", cursor: "pointer",
              fontSize: 14, fontWeight: 600, color: open === i ? "var(--purple3)" : "var(--text)",
              fontFamily: "var(--sans)", textAlign: "left",
            }}>
              {item.q}
              <span style={{ fontSize: 18, color: "var(--muted)", transition: "transform .2s", transform: open === i ? "rotate(45deg)" : "none" }}>+</span>
            </button>
            {open === i && (
              <div style={{ padding: "0 20px 16px", fontSize: 13, color: "var(--muted)", lineHeight: 1.7 }}>
                {item.a}
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
